export class Menupoint {
    name: string;
    label: string;
    targetUri: string;
    icon?: string;
    children: Menupoint[];
    requiredRights: number;
    alternatives: string[]; // alternative menupoints(name)
    defekt?: boolean = false;
    hidden?: boolean = false;
}
